// Native
import { useState } from "react"

// Components
import { AlertDialogBody, AlertDialogFooter, Button, ButtonGroup, List, ListIcon, ListItem, useDisclosure, useToast } from "@chakra-ui/react"
import { Alert, Dialog, Show } from "components"
import { TbCreditCard, TbNotification, TbReportMoney } from "react-icons/tb";

// Config
import { API } from "config"

// Hooks
import { useOrder } from "hooks"

// Screens
import { Authenticate } from "screens"

export default function Approve({ data, ...props }){

    const toast = useToast()
    const order = useOrder(data?.id)
    const [ loading, setLoading ] = useState(false)
    const authenticate = useDisclosure()

    const handleApprove = async () => {
        setLoading(true)

        try{
            await API.put(`/orders/${order.data.id}/approve`)
            toast({ title: 'O pedido foi aprovado', status: 'success' })
            order.refetch()
            props.onClose()
        }catch(err){
            toast({ title: 'Não foi possível aprovar o pedido.', description: err?.response?.data?.message, status: 'warning' })
        }

        setLoading(false)
    }

    return(
    <>
    <Dialog title={`Aprovar pedido #${order.data?.cod}`} loading={loading} {...props}>
        <AlertDialogBody fontSize="sm">
            Você está prestes a realizar a aprovação manual de um pedido. Após aprovado, fique atento aos efeitos colaterais 
            desta ação:
            <br />
            
            <Show visible={!order.data?.is_matriz}>
                <Alert status="warning" title="Você está aprovando um pedido de núcleo" my={4}>
                    Tenha em mente que este é um pedido de um núcleo de distribuição <b>{order.data?.distributor_from?.name}</b> e não da matriz ou filiais. Portanto, garanta autorização expressa para realizar esta ação.
                </Alert>
            </Show>

            <br />
            <b>O que acontece quando um pedido é aprovado?</b>
            <br />

            <List spacing={3} p={4} fontSize="xs">
                <ListItem><ListIcon as={TbReportMoney} color="orange" />Pontuação e bonificação gerada para este pedido será aplicada para a rede;</ListItem>
                <ListItem><ListIcon as={TbNotification} color="orange" />O cliente e núcleo serão notificados da aprovação;</ListItem>
            </List>

        </AlertDialogBody>
        <AlertDialogFooter>
            <ButtonGroup size="sm" isDisabled={loading}>
                <Button variant="ghost" children="Sim, desejo aprovar" isLoading={loading} loadingText="Aprovando pedido..." onClick={authenticate.onOpen} />
                <Button variant="ghost" colorScheme="red" children="Fechar" onClick={props.onClose} />
            </ButtonGroup>
        </AlertDialogFooter>
    </Dialog>

    <Authenticate {...authenticate} onSuccess={handleApprove} />
    </>
    )
}